module.exports = __webpack_public_path__ + "static/media/APA_2023Campaign_Banner.1cf0ef38.jpg";